module.exports = __webpack_public_path__ + "static/media/FontAwesome.a20ff02a.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/react-native-vector-icons/Fonts/FontAwesome.ttf
// module id = 788
// module chunks = 0